import { Injectable } from '@angular/core';

import { CanvasElementId, EmitsClick } from '@blaze-runtime/engine-domain';

/**
 * Remembers which button commits which form, so a field can submit the form it sits in
 * (e.g. on Enter) without knowing the button.
 *
 * Buttons are held weakly: a form whose button has been destroyed simply stops being
 * submittable, instead of keeping a dead component alive.
 */
@Injectable({ providedIn: 'root' })
export class FormCommitButtonRegistry {
  private readonly commitButtons = new Map<CanvasElementId, WeakRef<EmitsClick>>();

  register(formElementId: CanvasElementId, commitButton: EmitsClick): void {
    this.commitButtons.set(formElementId, new WeakRef(commitButton));
  }

  /** Clicks the form's commit button, as if the user had pressed it. */
  submit(formElementId: CanvasElementId): void {
    setTimeout(() => {
      // why: the field's value only reaches the form output after the current task, so
      // clicking synchronously would commit the value the user just replaced
      this.commitButtons.get(formElementId)?.deref()?.emitClick(true);
    });
  }
}
